"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectAttributeData = exports.createSDTFOverview = exports.collectSDTFItemData = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const gl_matrix_1 = require("gl-matrix");
const inputValidator = viewer_shared_services_1.InputValidator.instance;
const collectSDTFItemData = (node) => {
    for (let i = 0, len = node.data.length; i < len; i++)
        if (node.data[i] instanceof viewer_shared_types_1.SDTFItemData)
            return node.data[i];
    if (!node.parent)
        return;
    return (0, exports.collectSDTFItemData)(node.parent);
};
exports.collectSDTFItemData = collectSDTFItemData;
const createSDTFOverview = (node) => {
    const out = new viewer_shared_types_1.SDTFOverviewData({});
    node.traverseData((d) => {
        if (d instanceof viewer_shared_types_1.SDTFOverviewData) {
            out.merge(d);
        }
    });
    return out.overview;
};
exports.createSDTFOverview = createSDTFOverview;
const injectAttributeData = (renderingEngine, currentSDTFOverview, node, data) => {
    const itemData = (0, exports.collectSDTFItemData)(node);
    const visData = {
        material: new viewer_shared_types_1.MaterialStandardData({
            color: renderingEngine.defaultMaterialColor,
            opacity: 1,
        }),
        matrix: gl_matrix_1.mat4.create(),
    };
    if (renderingEngine.visualizeAttributes) {
        const userVisData = renderingEngine.visualizeAttributes(currentSDTFOverview, itemData);
        inputValidator.validateAndError("Viewer.visualizeAttributes", userVisData, "object", true);
        inputValidator.validateAndError("Viewer.visualizeAttributes", userVisData.matrix, "mat4", true);
        visData.material = userVisData.material;
        visData.matrix = userVisData.matrix;
    }
    node.addTransformation({
        id: "sdtf",
        matrix: visData.matrix,
    });
    if (data instanceof viewer_shared_types_1.GeometryData)
        data.attributeMaterial = visData.material;
};
exports.injectAttributeData = injectAttributeData;
//# sourceMappingURL=SDTFUtils.js.map